import { AboutSection } from 'ui/components';
import { useShouldShowContent } from 'helpers/audiencehelper';
export const AboutSectionFeature: React.FC<Umbraco.AboutSection> = ({ content }) => {
	const show = useShouldShowContent(content.properties.audiencePicker);

	return show ? <AboutSection {...content?.properties} /> : <></>;
};
